import React, { Component } from 'react'

class DashboardBox extends Component {
  render () {
    /* eslint-disable */
    return (
      <div className='namespace col-lg-2 col-md-3 col-sm-6 col-xs-12'>
        <div className='namespace-inner'>
          <div className='namespace-text'>
            <h3>{this.props.title}</h3>
            <i className={'fa fa-fw ' + this.props.icon} />
        </div>
        {this.props.buttons.map((button, i) => {
          return <a key={button.link} href={button.link} className={'btn' + (this.props.buttons.length > 1 ? ' half-width ' : ' full-width ') + (i > 0 ? ' btn-info ' : ' btn-primary ')}>{button.content}</a>
        })}
        </div>
      </div>
    )
  }
}
export default DashboardBox



// WEBPACK FOOTER //
// ./src/components/core/DashboardBox.js